import { motion, useReducedMotion } from "motion/react";
import { HeroPhoto } from "../OptimizedImage";
import { ResortLink } from "../resort-button";

export function MapPageHero() {
  const reduced = useReducedMotion();
  const ease = [0.22, 1, 0.36, 1] as const;

  return (
    <section
      id="top"
      aria-labelledby="map-hero-heading"
      className="relative min-h-[54svh] overflow-hidden bg-forest-deep md:min-h-[56svh]"
    >
      <motion.div
        className="absolute inset-0"
        initial={reduced ? false : { scale: 1.04 }}
        animate={{ scale: 1 }}
        transition={{ duration: 2, ease }}
      >
        <HeroPhoto alt="Aerial view of Auburn RV Resort grounds and RV sites in the Sierra Foothills" />
        <div className="overlay-cinematic absolute inset-0" />
      </motion.div>

      <div className="shell relative flex min-h-[54svh] flex-col justify-end pb-10 pt-18 md:min-h-[56svh] md:pb-14 md:pt-20">
        <motion.p
          className="eyebrow text-primary-foreground/80"
          initial={reduced ? false : { opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.15, ease }}
        >
          Find Your Way Around
        </motion.p>

        <h1
          id="map-hero-heading"
          className="display-xl mt-5 max-w-[14ch] text-primary-foreground"
        >
          <span className="block overflow-hidden">
            <motion.span
              className="display-xl block"
              initial={reduced ? false : { y: "110%" }}
              animate={{ y: "0%" }}
              transition={{ duration: 1, delay: 0.3, ease }}
            >
              Explore Auburn RV Resort
            </motion.span>
          </span>
        </h1>

        <motion.p
          className="mt-6 max-w-2xl text-base leading-relaxed text-primary-foreground/80 md:text-lg"
          initial={reduced ? false : { opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.7, ease }}
        >
          Get familiar with the resort before you arrive. Explore our site layout, find the areas
          that work best for your RV and then let our team help you determine what&apos;s available
          for your stay.
        </motion.p>

        <motion.div
          className="mt-8 flex w-full flex-col gap-3 sm:w-auto sm:flex-row"
          initial={reduced ? false : { opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.95, ease }}
        >
          <ResortLink variant="gold" href="#resort-map" className="w-full sm:w-auto">
            View Resort Map
          </ResortLink>
          <ResortLink variant="onDark" href="/reservations/" className="w-full sm:w-auto">
            Check Availability
          </ResortLink>
        </motion.div>

        <motion.p
          className="eyebrow mt-6 text-primary-foreground/60"
          initial={reduced ? false : { opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 1.1, ease }}
        >
          71 RV Sites · Pull-Through · Back-In · Accessible · Full Hookups
        </motion.p>
      </div>
    </section>
  );
}
